import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/CheckItemGroupExcelActions";
import * as api from "../../api/CheckItemGroupExcelApi";
import moment from "moment";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getExcelList(action) {
    yield put(resetBackdrop());
    try {
        if (action.payload.tabId == 0) {
            const { data } = yield api.postCheckItemGroupPlannedExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        } else if (action.payload.tabId == 1) {
            const { data } = yield api.postCheckItemGroupAutonomousExcelToList(action.payload.data);
            yield put(actions.setExcelList(data || undefined));
        }
    } catch (error) {
        yield put(showErrorSnackbar(error, "error"));
    }
    yield put(setBackdrop());
}

function* postExcelUpload(action) {
    yield put(resetBackdrop());
    try {
        if (action.payload.tabId == 0) {
            const { data } = yield api.postCheckItemGroupPlannedExcelUpload(action.payload.fileChecksum);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        } else if (action.payload.tabId == 1) {
            const { data } = yield api.postCheckItemGroupAutonomousExcelUpload(action.payload.fileChecksum);
            yield put(actions.postExcelUpload(data || undefined));
            yield put(showSuccessSnackbar(data.message));
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* downloadExcelFile(action) {
    yield put(resetBackdrop());
    try {
        let { data } = {};
        let name = "";
        if (action.payload.tabId == 0) {
            data = yield api.downloadCheckItemGroupPlannedExcel();
            name = "Planned";
        } else if (action.payload.tabId == 1) {
            data = yield api.downloadCheckItemGroupAutonomousExcel();
            name = "Autonomous";
        } 
        if (name != "") {
            const url = window.URL.createObjectURL(new Blob([data.data]));
            const link = document.createElement("a");
            link.href = url;
            const filename = "MOST_" + name + "_" + moment(new Date()).format("DD_MM_YYYY_HH_mm_ss") + ".xlsx"; //name with date time & extension
            link.setAttribute("download", filename); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.CHECKITEMGROUPEXCEL_GET_EXCEL_LIST, getExcelList);
    yield takeEvery(actions.Types.CHECKITEMGROUPEXCEL_UPLOAD_FILE, postExcelUpload);
    yield takeEvery(actions.Types.CHECKITEMGROUPEXCEL_EXCEL_FILE_OUTLINE, downloadExcelFile);
}

const CheckItemGroupExcelSaga = [fork(watchAll)];

export default CheckItemGroupExcelSaga;
